
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefcf5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefcf5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $800sp = parcelRequire("800sp");

var $4OBpG = parcelRequire("4OBpG");

var $j8Uso = parcelRequire("j8Uso");


var $6194a36855a3360e$var$_dec, $6194a36855a3360e$var$_dec2, $6194a36855a3360e$var$_class, $6194a36855a3360e$var$_class2, $6194a36855a3360e$var$_descriptor, $6194a36855a3360e$var$_AddressComponent;
function $6194a36855a3360e$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $6194a36855a3360e$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer && (Object.defineProperty(i, e, a), a = null), a;
}
function $6194a36855a3360e$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $6194a36855a3360e$export$5a8126faafbbb6bc = ($6194a36855a3360e$var$_dec = (0, $4OBpG.customElement)("address-component"), $6194a36855a3360e$var$_dec2 = (0, $4OBpG.property)({
    type: String
}), $6194a36855a3360e$var$_dec($6194a36855a3360e$var$_class = ($6194a36855a3360e$var$_class2 = ($6194a36855a3360e$var$_AddressComponent = class AddressComponent extends (0, $800sp.LitElement) {
    constructor(...args){
        super(...args);
        $6194a36855a3360e$var$_initializerDefineProperty(this, "address", $6194a36855a3360e$var$_descriptor, this);
    }
    firstUpdated() {
        const tooltipTriggerList = [].slice.call(this.shadowRoot?.querySelectorAll('[data-bs-toggle="tooltip"]') || []);
        tooltipTriggerList.map((tooltipTriggerEl)=>{
        //return new Tooltip(tooltipTriggerEl);
        });
        this.shadowRoot?.getElementById("ca-address")?.addEventListener("click", ()=>{
            const textarea = document.createElement("textarea");
            textarea.value = this.address;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand("copy");
            document.body.removeChild(textarea);
            const notyf = new (0, $j8Uso.Notyf)();
            notyf.success("copied CA address to clipboard");
        });
    }
    render() {
        return (0, $800sp.html)`
      <div class="col-12 text-center" style="margin-top: 2rem;">
        <copied-address></copied-address>
        <h1>
          <span class="vibrant-text"><strong>CA: </strong></span>
          <span id="ca-address" class="vibrant-text" data-bs-toggle="tooltip" data-bs-placement="top" title="Click to copy the token address">
            <strong>${this.address}</strong>
          </span>
        </h1>
      </div>
    `;
    }
}, $6194a36855a3360e$var$_AddressComponent.styles = (0, $800sp.css)`

  `, $6194a36855a3360e$var$_AddressComponent), $6194a36855a3360e$var$_descriptor = $6194a36855a3360e$var$_applyDecoratedDescriptor($6194a36855a3360e$var$_class2.prototype, "address", [
    $6194a36855a3360e$var$_dec2
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "SPL11111111111111111111111111";
    }
}), $6194a36855a3360e$var$_class2)) || $6194a36855a3360e$var$_class);


//# sourceMappingURL=index.6a4095ec.js.map
